const searchForm = document.querySelector('#search-form');
const searchContainer = document.querySelector('.search-filters__container');
const searchToggle = searchContainer.querySelector(
	':scope .search-filters__toggle'
);
const searchFilters = searchContainer.querySelectorAll(
	':scope .search-filters__item'
);

const toggleSearchDropdown = (e) => {
	if (e) {
		e.preventDefault();
	}
	searchContainer.classList.toggle('open');
};

const selectSearchFilter = (e) => {
	const displayValue = e.target.textContent;
	const key = e.target.dataset.key;
	const value = e.target.dataset.value;
	const inputs = document.querySelectorAll(
		'.search-field input[type=hidden]'
	);

	if (searchFilters.length) {
		searchFilters.forEach((searchFilter) => {
			searchFilter.classList.remove('active');
		});
	}
	e.target.classList.add('active');
	searchContainer.classList.remove('open');

	searchToggle.textContent = displayValue;

	if (inputs.length) {
		inputs.forEach((input) => {
			input.value = null;
		});
	}

	if ('sites__in' === key) {
		document.querySelector(
			'.search-field input[type=hidden][name=multisite]'
		).value = 1;
	}
	document.querySelector(
		'.search-field input[type=hidden][name=' + key + ']'
	).value = value;

	searchForm.submit();
};

const searchPage = () => {
	if (searchContainer) {
		const urlParams = new URLSearchParams(window.location.search);
		const postType = urlParams.get('post_type');
		const sitesIn = urlParams.get('sites__in');

		if (postType || sitesIn) {
			if (searchFilters.length) {
				searchFilters.forEach((searchFilter) => {
					searchFilter.classList.remove('active');
				});
			}
		}

		if (postType) {
			document
				.querySelector(
					'.search-filters__item[data-key="post_type"][data-value="' +
						postType +
						'"]'
				)
				.classList.add('active');
		}

		if (sitesIn) {
			document
				.querySelector(
					'.search-filters__item[data-key="sites__in"][data-value="' +
						sitesIn +
						'"]'
				)
				.classList.add('active');
		}

		searchToggle.addEventListener('click', toggleSearchDropdown);

		if (searchFilters.length) {
			searchFilters.forEach((searchFilter) => {
				searchFilter.addEventListener('click', selectSearchFilter);
			});
		}
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		searchPage();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
